import { Clock, Mail, MapPin, Navigation } from 'lucide-react';
import ProgramJourney, { CLUB_ADDRESS } from './ProgramJourney';
import { publicHref } from '../lib/publicUrls';

// Book a Tour as a short guided journey (owner direction, Sept 30): it opens straight onto the first
// question, one interest group per screen, then name and contact, then the review. It sends exactly
// the same inquiry as the previous tour form. Every page closes with the same form (owner direction,
// Sept 30); see TourClosing below.

const DIRECTIONS = 'https://www.google.com/maps/search/?api=1&query=Delta+Valley+Health+Club+120+Guthrie+Ln+Brentwood+CA';
const TOUR_BREAKDOWN = 'Tap what you’d like to see, then how to reach you. About a minute, no commitment. Tours are at our Brentwood club.';

export default function TourJourney({ id, defaultInterests = ['Membership'], welcomeLevel = 'h1' }) {
  return (
    <ProgramJourney
      id={id} testId="tour-journey" welcomeLevel={welcomeLevel} progressLabel="Tour planning steps"
      source="book-a-tour" location="Brentwood" defaultInterests={defaultInterests}
      guided breakdown={TOUR_BREAKDOWN} eyebrow="Book a Tour"
      photo="C01"
      planTitle="Your tour plan" request={['Club', 'Brentwood · 120 Guthrie Ln.']}
      interestsLabel="You’d like to see" interestsEmpty="The whole club"
      nameQuestion="Who’s coming in?" nameLede="So our team knows who to welcome at the front desk." nameLabel="Guest"
      reachLede="We’ll only use this to set up your tour."
      reviewNoun="tour plan" reviewLede="Take a look, then send it to our membership team."
      buttonText="Request My Tour"
      successTitle="Tour Request Received" successHeading="You’re on the list"
      successMessage="Our membership team will contact you to schedule your visit."
      successNext={[
        [Mail, 'We reach out', ({ form }) => 'By email or phone, to find a time that works for you.'],
        [Clock, 'Pick your time', 'Monday–Thursday 4:30am–10:30pm, Friday 4:30am–9:00pm, weekends 6:00am–6:00pm.'],
        [MapPin, 'Come see the club', CLUB_ADDRESS],
      ]}
      successActions={(
        <>
          <a className="dv-button dv-button--light" href={DIRECTIONS} target="_blank" rel="noopener noreferrer"><Navigation size={16} aria-hidden="true" /> Get Directions</a>
          <a className="dv-button dv-button--outline-light" href={publicHref('/programs')}>Explore Programs</a>
        </>
      )}
    />
  );
}

// The tour request as the last section of a page, in place of a "Book a Tour" button: the same
// guided form as the Book a Tour page, under a section heading.
export const TourClosing = () => <TourJourney id="plan-your-visit" welcomeLevel="h2" />;
